import { eq } from "drizzle-orm";
import { salesOrders, salesOrderLines, counterparties, clientPayments, commissionAccruals } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { postClientPayment } from "./documents/client-payment.js";
import { resolveCommissionRate, computeCommission, postCommissionAccrual } from "./documents/commission-accrual.js";

type Db = TestDb;

export async function handleOrderPaid(
  db: Db, input: { orderId: string; cashAccountId: string; actorId: string },
): Promise<{ commissionKopecks: number | null }> {
  const [order] = await db.select().from(salesOrders).where(eq(salesOrders.id, input.orderId));
  if (!order) throw new Error(`SALES_ORDER_NOT_FOUND: ${input.orderId}`);
  const lines = await db.select().from(salesOrderLines).where(eq(salesOrderLines.orderId, input.orderId));
  const totalKopecks = lines.reduce((s, l) => s + l.priceKopecks * l.qty, 0);

  // Оплата клиента (аванс — заказ ещё не отгружен): −долг клиента / +касса. Отгрузка (№3) позже нетит.
  const [pay] = await db.insert(clientPayments)
    .values({ counterpartyId: order.counterpartyId, cashAccountId: input.cashAccountId, amountKopecks: totalKopecks })
    .returning();
  await postClientPayment(db, pay.id, input.actorId);

  // Комиссия барберу — только для реф-клиента, триггер на оплате (деньги пришли).
  const [client] = await db.select().from(counterparties).where(eq(counterparties.id, order.counterpartyId));
  if (!client?.referredByCounterpartyId) return { commissionKopecks: null };

  const rate = await resolveCommissionRate(db, client.referredByCounterpartyId);
  const commissionKopecks = computeCommission(totalKopecks, rate);
  const [acc] = await db.insert(commissionAccruals)
    .values({
      barberCounterpartyId: client.referredByCounterpartyId,
      sourceOrderId: order.id,
      rate: rate.toFixed(4),
      amountKopecks: commissionKopecks,
    })
    .returning();
  await postCommissionAccrual(db, acc.id);
  return { commissionKopecks };
}
